export default {
  baseStyle: {
    container: {
      _checked: {
        boxShadow: 'outline',
      },
    },
  },
}
